import withSuspense, { lazyRetry } from './Suspense';

export default withSuspense;
export { lazyRetry };
